import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';

@Component({
  selector: 'app-cadastro-endereco',
  templateUrl: './cadastro-endereco.component.html',
  styleUrls: ['./cadastro-endereco.component.scss'],
})
export class CadastroEnderecoComponent implements OnInit {
  // variaveis de entrada
  @Input() public exibir: boolean = false;
  @Input() public tipoAcao: number = 0;
  @Input() public endereco: any = undefined;
  @Input() public idIndex: number = 0;
  // variaveis de saida
  @Output() public novoEnderecoEvent: EventEmitter<any> = new EventEmitter();
  @Output() public atualizarEnderecoEvent: EventEmitter<any> =
    new EventEmitter();
  @Output() public cancelarFormEvent: EventEmitter<null> = new EventEmitter();
  @Output() public excluirEnderecoEvent: EventEmitter<any> = new EventEmitter();
  @Output() public tornarEnderecoPrincipalEvent: EventEmitter<any> =
    new EventEmitter();
  // consts
  private readonly FALHA: number = 0;
  private readonly SUCESSO: number = 1;
  private readonly EXIBICAO: number = 2;
  public readonly CADASTRO: number = 0;
  public readonly LISTAGEM: number = 1;

  public enderecoForm: UntypedFormGroup;
  public salvandoEndereco: boolean = false;
  public controleExibicaoDropdown: boolean = false;
  public controleExibicaoDescricao: boolean = false;
  public controleExibicaoEndereco: boolean = false;
  public habilitarCampoLogradouro: boolean = false;
  public habilitarCampoBairro: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private fb: UntypedFormBuilder,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.registrarForm();

    if (this.endereco != undefined) {
      this.preencherDadosDeEndereco(
        this.endereco.pais,
        this.endereco.estado,
        this.endereco.cidade,
        this.endereco.bairro,
        this.endereco.logradouro,
        this.endereco.cep,
        this.endereco.numero,
        this.endereco.complemento,
        this.EXIBICAO,
        this.endereco.descricao,
        this.endereco.enderecoPrincipal
      );
    }

    this.enderecoForm.valueChanges.subscribe((result: any) =>
      this.atualizarDadosEndereco(result)
    );

    if (this.tipoAcao === this.CADASTRO) this.exibirLabelDescricao(false);
    else this.exibirLabelDescricao(true);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event.target.className.includes('dropdown-toggle')) {
      this.controleExibicaoDropdown = false;
    }
  }

  public cadastrarEndereco(): void {
    if (!this.enderecoForm.dirty || !this.enderecoForm.valid) return;

    this.enderecoForm.value.enderecoPrincipal = false;
    this.novoEnderecoEvent.emit(this.enderecoForm.value);
  }

  public cancelarCadastro(): void {
    this.cancelarFormEvent.emit();
  }

  public buscarCep(evento: any): void {
    console.log(evento);
    const cep = evento.target.value.replace('-', '');
    if (cep.length !== 8) return;

    this.fidelidadeService.obterCep(cep).subscribe(
      (res) => this.processarSucessoBuscaCep(res),
      (err) => this.processarFalhaBuscaCep(err)
    );
  }

  public obterIconeDescricao(enderecoPrincipal: boolean): string {
    const pathIcon = 'assets/images/icons/';
    return enderecoPrincipal
      ? `${pathIcon}house.png`
      : `${pathIcon}location.png`;
  }

  public removerEndereco(): void {
    this.excluirEnderecoEvent.emit(this.idIndex);
  }

  public tornarPrincipal(): void {
    this.tornarEnderecoPrincipalEvent.emit(this.idIndex);
  }

  public exibirLabelDescricao(show: boolean): void {
    if (this.tipoAcao === this.CADASTRO) {
      this.controleExibicaoDescricao = false;
      return;
    }

    this.controleExibicaoDescricao = show;

    // const enderecoControl = this.el.nativeElement.querySelector(
    //     '[formcontrolname="descricao"]');

    // enderecoControl.focus();
  }

  public atualizarDadosEndereco(dados: any): void {
    if (!this.enderecoForm.valid || this.tipoAcao == this.CADASTRO) return;

    this.atualizarEnderecoEvent.emit(this.enderecoForm.value);
  }

  private processarSucessoBuscaCep(res: any): void {
    this.preencherDadosDeEndereco(
      'Brasil',
      res.uf,
      res.localidade,
      res.bairro,
      res.logradouro,
      '',
      '',
      '',
      this.SUCESSO,
      this.endereco?.descricao,
      this.endereco?.enderecoPrincipal
    );
  }

  public abrirOpcoes(id: string) {
    this.controleExibicaoDropdown = !this.controleExibicaoDropdown;
  }

  private processarFalhaBuscaCep(err: any): void {
    this.preencherDadosDeEndereco(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      this.FALHA,
      '',
      false
    );
  }

  private preencherDadosDeEndereco(
    pais: string,
    estado: string,
    cidade: string,
    bairro: string,
    logradouro: string,
    cep: string,
    numero: string,
    complemento: string,
    acao: number,
    descricao: string,
    enderecoPrincipal: boolean
  ): void {
    this.enderecoForm.controls['pais'].setValue(pais);
    this.enderecoForm.controls['estado'].setValue(estado);
    this.enderecoForm.controls['cidade'].setValue(cidade);
    this.enderecoForm.controls['bairro'].setValue(bairro);
    this.enderecoForm.controls['logradouro'].setValue(logradouro);
    this.enderecoForm.controls['enderecoPrincipal'].setValue(enderecoPrincipal);

    if (acao === this.SUCESSO) {
      this.enderecoForm.controls['complemento'].enable();
      this.enderecoForm.controls['numero'].enable();
      //this.enderecoForm.controls['logradouro'].disable();

      const enderecoControl = this.el.nativeElement.querySelector(
        '[formcontrolname="numero"]'
      );

      this.controleExibicaoEndereco = true;
      enderecoControl.focus();
    } else if (acao === this.FALHA) {
      this.enderecoForm.controls['descricao'].setValue('');
      //this.enderecoForm.controls['logradouro'].setValue('');
      this.enderecoForm.controls['complemento'].setValue('');
      this.enderecoForm.controls['numero'].setValue('');

      //this.enderecoForm.controls['logradouro'].disable();
      this.enderecoForm.controls['complemento'].disable();
      this.enderecoForm.controls['numero'].disable();
      this.controleExibicaoEndereco = false;
    } else if (acao == this.EXIBICAO) {
      this.enderecoForm.controls['descricao'].setValue(descricao);
      this.enderecoForm.controls['cep'].setValue(cep);
      this.enderecoForm.controls['complemento'].setValue(complemento);
      this.enderecoForm.controls['numero'].setValue(numero);
      this.controleExibicaoEndereco = true;
    }

    this.habilitarCampoLogradouro = logradouro == '';
    this.habilitarCampoBairro = bairro == '';
  }

  private registrarForm() {
    this.enderecoForm = this.fb.group({
      idControle: [this.idIndex],
      cep: ['', [Validators.required, Validators.minLength(8)]],
      logradouro: ['', [Validators.required]],
      bairro: ['', [Validators.required]],
      cidade: [''],
      estado: [''],
      numero: ['', [Validators.required]],
      complemento: [''],
      pais: [''],
      enderecoPrincipal: [false],
      descricao: ['', [Validators.required]],
    });
  }
}
